const MODULE_NAME = 'WorkInstructionModule';

export const LOCAL_ADD_WORK_INSTRUCTION_PACKAGE =
  'LOCAL_ADD_WORK_INSTRUCTION_PACKAGE';
export const LOCAL_DELETE_WORK_INSTRUCTION_PACKAGE =
  'LOCAL_DELETE_WORK_INSTRUCTION_PACKAGE';
export const LOCAL_RENAME_WORK_INSTRUCTION_PACKAGE = `${MODULE_NAME}/LOCAL_RENAME_WORK_INSTRUCTION_PACKAGE`;
export const LOCAL_GET_WORK_INSTRUCTION_PACKAGES =
  'LOCAL_GET_WORK_INSTRUCTION_PACKAGES';
export const LOCAL_SET_CURRENT_WORK_INSTRUCTION_PACKAGE = `${MODULE_NAME}/LOCAL_SET_CURRENT_WORK_INSTRUCTION_PACKAGE`;
export const LOCAL_ADD_WORK_INSTRUCTION = 'LOCAL_ADD_WORK_INSTRUCTION';
export const LOCAL_UPDATE_WORK_INSTRUCTION = 'LOCAL_UPDATE_WORK_INSTRUCTION';
export const LOCAL_DELETE_WORK_INSTRUCTION = 'LOCAL_DELETE_WORK_INSTRUCTION';
export const LOCAL_ADD_WORK_INSTRUCTION_STEP =
  'LOCAL_ADD_WORK_INSTRUCTION_STEP';
export const LOCAL_UPDATE_WORK_INSTRUCTION_STEP =
  'LOCAL_UPDATE_WORK_INSTRUCTION_STEP';
export const LOCAL_DELETE_WORK_INSTRUCTION_STEP =
  'LOCAL_DELETE_WORK_INSTRUCTION_STEP';
export const LOCAL_SET_WORK_INSTRUCTION_PACKAGES =
  'LOCAL_SET_WORK_INSTRUCTION_PACKAGES';
export const LOCAL_SET_WORK_INSTRUCTIONS_FOR_PACKAGE =
  'LOCAL_SET_WORK_INSTRUCTIONS_FOR_PACKAGE';
export const LOCAL_SET_FILES_LINKED_TO_WORK_INSTRUCTION_STEP =
  'LOCAL_SET_FILES_LINKED_TO_WORK_INSTRUCTION_STEP';
export const LOCAL_SET_TASKS_TO_WORK_INSTRUCTION_STEP =
  'LOCAL_SET_TASKS_TO_WORK_INSTRUCTION_STEP';
export const LOCAL_CHANGE_WORK_INSTRUCTIONS_ORDER =
  'LOCAL_CHANGE_WORK_INSTRUCTIONS_ORDER';
export const LOCAL_CHANGE_WORK_INSTRUCTION_STEPS_ORDER =
  'LOCAL_CHANGE_WORK_INSTRUCTION_STEPS_ORDER';
export const LOCAL_SET_WORK_INSTRUCTIONS_ORDER =
  'LOCAL_SET_WORK_INSTRUCTIONS_ORDER';
export const LOCAL_SIGN_OFF_STEP = 'LOCAL_SIGN_OFF_STEP';
export const LOCAL_SET_FILES_LINKED_TO_WORK_INSTRUCTION =
  'LOCAL_SET_FILES_LINKED_TO_WORK_INSTRUCTION';
export const LOCAL_SET_TASKS_TO_WORK_INSTRUCTION =
  'LOCAL_SET_TASKS_TO_WORK_INSTRUCTION';
export const LOCAL_SET_JOB_WORK_INSTRUCTION_STATUS =
  'LOCAL_SET_JOB_WORK_INSTRUCTION_STATUS';
export const LOCAL_ADD_COMMENT_TO_STEP = 'LOCAL_ADD_COMMENT_TO_STEP';
export const LOCAL_SET_ALL_WORK_INSTRUCTIONS_BY_PACKAGE =
  'LOCAL_SET_ALL_WORK_INSTRUCTIONS_BY_PACKAGE';
export const LOCAL_REOPEN_STEP = 'LOCAL_REOPEN_STEP';
